import { createContext } from "react";

import { CareProducts, TestProducts } from "@/pages/shopAll/types";

export type ProductsContextType = {
  allProducts?: {
    care_products?: CareProducts;
    test_products?: TestProducts;
  };
  error: any;
  isLoading: boolean;
  refetchAllProducts: () => void;
};

export const ProductsContext = createContext<ProductsContextType>({
  allProducts: undefined,
  error: null,
  isLoading: true,
  refetchAllProducts: () => {},
});
